import axios from "axios";
import { api } from './api'
import { URL } from '../utils/constant'



export const getFeeds = () => api.get(URL.feeds);

export const getMyIdeas = () => api.get(URL.myIdeas);

export const getlatestIdeas = () => api.get(URL.latestIdeas);

export const getIdea = (id) => api.get(`${URL.ideasReview}/${id}`)

export const getIdeaDetail = (id) => api.get(`${URL.ideaDetail}/${id}`)

export const getTopIdeas = (empId) => api.get(URL.topIdeas, { params: { empId } });

export const getTrendIdeas = (empId) => api.get(URL.trendIdeas);

export const topEmployees = () => api.get(URL.topEmp)


export const createReaction = (reactionId, ideaId, action) => {
    return api.post(URL.reaction, JSON.stringify({
        reactionId: reactionId,
        ideaId: ideaId,
        action: action
    }), {
        headers: {
            "content-type": "application/json"
        }
    })
}

export const deleteReaction = (reactionId) => {
    return api.delete(`${URL.reaction}/${reactionId}`)
}

export const getComments = (ideaId) => {
    return api.get(`${URL.comment}${ideaId}`);
}

export const createComment = (ideaId, commentText, empId, empName) => {
    return api.post(URL.comment, JSON.stringify({
        ideaId: ideaId,
        commentText: commentText,
        empId: empId,
        empName: empName
    }), {
        headers: {
            "content-type": "application/json"
        }
    })
}

export const uploadAttachment = (file, setFiles, fileName, cancelToken) => {
    return api.post(URL.upload, file, {
        headers: {
            "content-type": "application/json"
        },
        cancelToken: cancelToken.token,
        onUploadProgress: ({ loaded, total }) => {
            setFiles((prevState) =>
                prevState.filter((prevItem) => {
                    if (prevItem.name == fileName) {
                        prevItem.progress = loaded / total * 100

                    }
                    return prevItem
                })
            );
        }
    })
        .catch(error => {

        });
}

export const deleteUploadedAttachment = (fileName) => {
    return api.get(`${URL.upload}/${fileName}`)
}

export const getImplementAreas = () => {
    return api.get(URL.implementAreas)
}

export const getExpectedOutcomes = () => {
    return api.get(URL.expectedOutcomes)
}

export const getCategoryList = () => {
    return api.get(URL.categoryList)
}

export const getDepartmentList = () => {
    return api.get(URL.departmentList)
}

export const getProfile = () => {
    return api.get(URL.profile)
}

export const postNewIdea = (ideaDesc, isImplemented, isImplementedText, implementArea, isForDepartment, benefits, files, postType, outcomeArea) => {
    return api.post(URL.postIdea, JSON.stringify({
        ideaDesc: ideaDesc,
        isImplemented: isImplemented,
        isImplementedText: isImplementedText,
        isForDepartment: isForDepartment,
        benefits: benefits,
        implementArea: implementArea,
        files: files,
        postType: postType,
        outcomeArea: outcomeArea
    }), {
        headers: {
            "content-type": "application/json"
        }
    })
}

export const postPhuketIdea = (ideaDesc, implementArea) => {
    return api.post(URL.postPhuketIdea, JSON.stringify({
        ideaDesc: ideaDesc,

        implementArea: implementArea,
    }), {
        headers: {
            "content-type": "application/json"
        }
    })
}

export const updateIdeaStatus = (ideaId, ideaStatus, ideaCategory, ideaDepartment) => {
    return api.post(URL.updateIdeaStatus, JSON.stringify({
        ideaId: ideaId,
        status: ideaStatus,
        category: ideaCategory,
        department: ideaDepartment
    }), {
        headers: {
            "content-type": "application/json"
        }
    })
}
export const postFeedback = (type, desc, area) => {
    return api.post(URL.postFeedback, JSON.stringify({
        type: type,
        desc: desc,
        area: area
    }), {
        headers: {
            "content-type": "application/json"
        }
    })
}